<template>
  <section class="page-section" v-loading="pageLoading">

        <el-form size="small" :model="form" :rules="rules" label-width="110px"
          class="content-form no-padding-bottom pt20" ref="form">
          <el-form-item label="代理商等级" prop="rank">
            <el-select v-model="form.rank" placeholder="请选择代理商等级">
              <el-option label="一级代理商" value="parent"></el-option>
              <el-option label="二级代理商" value="child"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="代理姓名" prop="name">
            <el-input class="w300" v-model="form.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input class="w300" v-model="form.mobile" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="服务分佣比例" prop="servicePercentage">
            <el-input class="w300" v-model="form.servicePercentage" placeholder="请输入"
              @input="form.servicePercentage = form.servicePercentage.replace(/[^0-9]/g, '')"></el-input>
            <span> %</span>
          </el-form-item>
          <el-form-item label="商品分佣比例" prop="productPercentage">
            <el-input class="w300" v-model="form.productPercentage" placeholder="请输入"
              @input="form.productPercentage = form.productPercentage.replace(/[^0-9]/g, '')"></el-input>
            <span> %</span>
          </el-form-item>
          <el-form-item label="上级代理商" prop="parentId" v-if="form.rank === 'child'">
            <el-select v-model="form.parentId" filterable placeholder="请选择上级代理">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="handleCommit('form')" :loading="btnLoading">确定</el-button>
            <el-button size="small" type="default" plain @click="handleback">取消</el-button>
          </el-form-item>
        </el-form>
      </section>
</template>

<script>
import { agentCompanySaveOrUpdate, agentCompanylistAll } from '../../../common/api';

export default {
  data() {
    return {
      id: '',
      form: {
        name: '',
        mobile: '',
        servicePercentage: '',
        productPercentage: '',
        rank: '',
        parentId: ''
      },
      options: [],
      pageLoading: false,
      btnLoading: false,
      rules: {
        name: [
          { required: true, message: '请输入代理姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        servicePercentage: [
          { required: true, message: '请输入分佣比例', trigger: 'blur' }
        ],
        rank: [
          { required: true, message: '请选择代理商等级', trigger: 'blur' }
        ],
        productPercentage: [
          { required: true, message: '请输入分佣比例', trigger: 'blur' }
        ],
        parentId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.form.rank === 'child' && !value) {
                callback(new Error('请选择上级代理'));
              } else {
                callback();
              }
            }, trigger: 'change'
          }
        ]
      }
    }
  },
  mounted() {
    let query = this.$route.query
    if (query && query.row && query.row.id) {
      const { name, contact, mobile, password, servicePercentage, productPercentage, parentId, id } = query.row
      this.id = id
      if (parentId) {
        this.form.rank = 'child'
      } else {
        this.form.rank = 'parent'
      }
      let formAssign = {
        name,
        contact,
        mobile,
        password,
        servicePercentage,
        productPercentage
      };

      if (parentId) {
        formAssign.parentId = parentId;
      }

      Object.assign(this.form, formAssign)
    }
    this.getAgentList()
  },
  methods: {
    getAgentList() {
      let param = {
        type: 1,
        parentId: 0
      }
      this.pageLoading = true;
      agentCompanylistAll(param).then(res => {
        this.pageLoading = false;
        console.log(res)
        let { code, data, msg } = res;
        if (code == 0) {
          this.options = data || [];
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.pageLoading = false;
        this.$message.error('服务器异常');
      });
    },
    // 提交
    handleCommit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          const { name, mobile, servicePercentage, productPercentage } = this.form
          let param = {
            type: 1,
            name,
            mobile,
            servicePercentage,
            productPercentage,
            id: this.id
          }

          if (this.form.parentId && this.form.rank === 'child') {
            param.parentId = this.form.parentId
          }
          if (this.id == this.form.parentId && this.form.rank === 'child') {
            this.$message.error('上级代理不能是自己')
            return
          }
          this.btnLoading = true;
          agentCompanySaveOrUpdate(param).then(res => {
            this.btnLoading = false;

            let { code, data, msg } = res;

            if (code == 0) {
              this.$message.success('保存成功');
              this.handleback()
            } else {
              this.$message.error(msg);
            }
          }).catch(error => {
            this.btnLoading = false;
            this.$message.error('服务器异常');
          });

        } else {
          return false;
        }
      });
    },
    /**
     * [handleback description] 取消-返回列表
     * @return {[type]}          [description]
     */
    handleback: function () {
      this.$router.push('/agent/person/list');
    },
  }
}
</script>

<style lang="scss" scoped></style>
